import { TTableStructure, ETableStructureType, ETableStructureAlign } from 'ui/EasTable/types';
import { DATES, DATES_ID } from 'services/constants/dates-constants';
import { Download, Edit, Receipt } from '@mui/icons-material';
import { TEmCommentItem } from 'redux/reducers/emManagement/types';
import { EIconButtons } from '../../../../../ui/EasTable/EasTableRow/EasTableValue/constants';
import { formatScheduledActionOnForDisplay } from './utils';

export const tableStructure: TTableStructure<keyof TEmCommentItem>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Scheduled Action On',
		selector: 'scheduledActionOn',
		value: (item: TEmCommentItem) => formatScheduledActionOnForDisplay(item.scheduledActionOn),
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		editable: true,
	},

	{
		name: 'Comment',
		selector: 'comment',
		show: true,
		sortable: false,
		filterable: true,
		searchable: true,
		colSpan: 2,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
		editable: true,
	},

	{
		name: 'EM ID',
		selector: 'emId',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.CENTER,
		editable: false,
	},

	{
		name: 'Notified',
		selector: 'isNotified',
		show: false,
		sortable: false,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.CENTER,
		filter: [
			['true', 'Yes'],
			['false', 'No'],
		],
		colors: [
			['true', 'success.light'],
			['false', 'warning.light'],
		],
		editable: false,
		disabledRowFn: (item: TEmCommentItem) => item.isNotified,
	},

	{
		name: 'Operators To Notify',
		selector: 'operatorsToNotify',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.USERS,
		align: ETableStructureAlign.LEFT,
		editable: true,
	},
	{
		name: 'Created At',
		selector: 'createdAt',
		show: true,
		sortable: false,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
			[DATES_ID.CUSTOM_RANGE, DATES.CUSTOM_RANGE],
		],
		editable: false,
	},

	{
		name: 'Created By',
		selector: 'createdBy',
		show: true,
		sortable: false,
		filterable: true,
		colSpan: 2,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
	},

	{
		name: 'Actions',
		noName: true,
		selector: 'id',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.RIGHT,
		buttons: [
			{
				name: 'Edit',
				icon: EIconButtons.EDIT,
			},
		],
	},
];
